require('./amazonGiftCardPromotionBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { PROMOCIONES_TEXT } = require('constants/accountAmazonGiftCard');
//@utils
const {
    recordLinkV2
} = require("utilities/tagging");
//@constant
const {
    AMAZON_PROMOCIONES_COMAPRE_BUTTON,
    AMAZON_PROMOCIONES_CONDITIONS_LINK,
    AMAZON_PROMOCIONES
} = require('constants/tagging');

class AmazonGiftCardPromotionBox extends React.Component {

    handleRecordLink(accionEvento) {
        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES,
            accionEvento,
            etiquetaEvento: PROMOCIONES_TEXT
        });
        recordLinkV2(customData);
    }

    render() {
        const { promotionAd, selectedAccount } = this.props;
        let compareButton;
        const accountId = selectedAccount.get('accountId');

        const image = promotionAd.get('fieldImageLarge') && (
            <img className="amazon-gift-card-promotion-box__image" src={promotionAd.get('fieldImageLarge')} />
        );

        const body = promotionAd.get('body') && (
            <HTMLSafeInjector
                customClass="amazon-gift-card-promotion-box__step-description"
                message={promotionAd.get('body')}
            />
        );

        const basesLink = promotionAd.get('fieldLink') && (
            <div className="amazon-gift-card-promotion-box__details-footer-bases-link">
                <OKLink
                    modifier="editorial"
                    target="_blank"
                    title={formatText('amazonGiftCard-promotionLink')}
                    to={promotionAd.get('fieldLink')}
                    onClick={() => this.handleRecordLink(AMAZON_PROMOCIONES_CONDITIONS_LINK)}
                >
                    <span>{promotionAd.get('fieldText')}</span>
                </OKLink>
            </div>
        );

        const toLink = `/myprofile/accounts/${accountId}/buy-amazon-gift-card`
        compareButton = (
            <div className="amazon-gift-card-promotion-box__details-footer-compare-button">
                <OKButton
                    modifier="primary"
                    size="small"
                    to={toLink}
                    onClick={() => this.handleRecordLink(AMAZON_PROMOCIONES_COMAPRE_BUTTON)}
                >
                    <FormattedText value="amazonGiftCard-promotionBoxButtonText" />
                </OKButton>
            </div>
        );

        return (
            <section
                className="amazon-gift-card-promotion-box"
            >
                <section className="amazon-gift-card-promotion-box__promo-section row">
                    <div className="row">
                        <div className="col-xs-5 amazon-gift-card-promotion-box__image">
                            {image}
                        </div>
                        <div className="col-xs-7">
                            <div className="amazon-gift-card-promotion-box__details">
                                <div className="amazon-gift-card-promotion-box__details-step">
                                    {body}
                                </div>
                                <div className="amazon-gift-card-promotion-box__details-footer">
                                    {basesLink}
                                    {compareButton}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="amazon-gift-card-promotion-box__disclaimer-text row">
                        <OKMessage type="informative">
                            <FormattedText value="buyAmazonGiftCard-disclaimerText"
                            />
                        </OKMessage>
                    </div>
                </section>
            </section>
        )
    }
}

AmazonGiftCardPromotionBox.propTypes = {
    promotionAd: PropTypes.object.isRequired,
    selectedAccount: PropTypes.object.isRequired,
};

module.exports = AmazonGiftCardPromotionBox;
